export const EmailTaURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/TaInvitationMail";
export const OnRegisteredUserURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/OnRegisteredUserMail";

export const DeleteUserURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/DeleteUser";

export const ContactUsURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/ContactUsMail";
export const OnPeerCompleteToOwnerURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/OnPeerCompleteToOwnerMail";

export const OnEvaluationCompleteURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/OnEvaluationCompleteMail";

export const PeerInvitationMailURL =
  "https://us-central1-ilead-2154a.cloudfunctions.net/PeerInvitationMail";





// WEBPACK FOOTER //
// ./src/modules/emails/endpoints.js